module.exports = __webpack_public_path__ + "static/media/ls_logo.b65b2a43.png";